import Vue from 'vue';
import VueRouter from 'vue-router';

import DefaultLayout from '@/layouts/default-layout.vue';
import RouteShell from '@/layouts/route-shell.vue';
import ClosureBoard from '@/views/closure-board/index.vue';
import CurrentBatch from '@/views/data-ops/index.vue';
import DataSource from '@/views/data-source/index.vue';
import LiveBoard from '@/views/live-board/index.vue';
import LiveDetail from '@/views/live-detail/index.vue';
import LiveEditor from '@/views/live-editor/index.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        { path: '', redirect: 'dashboard' },
        {
          path: 'live',
          component: RouteShell,
          meta: { title: '新系统' },
          redirect: { name: 'live-board' },
          children: [
            {
              path: 'board',
              name: 'live-board',
              component: LiveBoard,
              meta: { title: '看板' },
            },
            {
              path: 'detail',
              name: 'live-detail',
              component: LiveDetail,
              meta: { title: '明细' },
            },
            {
              path: 'editor',
              name: 'live-editor',
              component: LiveEditor,
              meta: { title: '投诉表编辑' },
            },
          ],
        },
        { path: 'live-board', redirect: { name: 'live-board' } },
        { path: 'live-detail', redirect: { name: 'live-detail' } },
        { path: 'live-editor', redirect: { name: 'live-editor' } },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: ClosureBoard,
          meta: { title: '闭环看板' },
        },
        {
          path: 'data-ops',
          name: 'data-ops',
          component: CurrentBatch,
          meta: { title: '投诉明细' },
        },
        {
          path: 'data-source',
          name: 'data-source',
          component: DataSource,
          meta: { title: '数据源' },
        },
        { path: 'import-view', redirect: 'data-ops' },
      ],
    },
  ],
});
